import Raven from 'raven-js'
import moment from 'moment'
import StackTrace from 'stacktrace-js'
import { get, last } from 'lodash'

class ErrorTracker {
  constructor() {
    this.currentRoute = null
  }

  setRoute(route) {
    this.currentRoute = route
  }

  /*
  Exclude packages from stack trace so we can get a clean
  look into what's breaking
*/
  applicationTrace(stack) {
    return stack
      .filter(line => !line.fileName.includes('node_modules'))
      .map(l => l.toString())
      .join('\n')
  }

  /*
  Roughly guesses which container this error originated from
  */
  extractFile(stack) {
    const filename = stack.length && stack[0].fileName

    if (!filename) {
      return
    }

    const fileNameWithoutPrefix = last(filename.split('/'))
    return fileNameWithoutPrefix
  }

  extractFunction(stack) {
    const functionName = stack.length && stack[0].functionName
    return functionName
  }

  /*
  Tap into Apollo's internal query manager and extract
  some metadata from the queries.
  That should gives insight into which queries have run.
*/
  failedApolloQueries() {
    const queryStore = get(
      window,
      '__APOLLO_CLIENT__.queryManager.queryStore.store'
    )

    if (!queryStore) {
      return
    }

    const queries = Object.values(queryStore)
    const failedQueries = queries.filter(
      query => query.graphQLErrors.length > 0 || query.networkError
    )
    return failedQueries.map(query => {
      return {
        errors: query.graphQLErrors,
        queryString: query.queryString,
        networkError: query.networkError,
        component: get(query, 'metadata.reactComponent.displayName')
      }
    })
  }

  async extractErrorInfo(error, options = {}) {
    // TODO: check for the Fullstory vs UserId mismatch
    const stack = await StackTrace.fromError(error)

    const fullStory = this.getFullStory()
    const timezone = moment.tz.guess()
    const sentryId = Raven.lastEventId()
    const appTrace = this.applicationTrace(stack)
    const filename = this.extractFile(stack)
    const functionName = this.extractFunction(stack)
    const failedGraphQLQueries = this.failedApolloQueries()
    const route = this.currentRoute

    const extraInfo = {
      timezone,
      sentryId,
      appTrace,
      filename,
      functionName,
      failedGraphQLQueries,
      fullStory,
      route,
      ...options
    }

    return extraInfo
  }

  getFullStory() {
    if (!window.FS) {
      return
    }

    return window.FS.getCurrentSessionURL(true)
  }

  logFullStory(message) {
    window.FS && window.FS.log('error', message)
  }
}

export default new ErrorTracker()
